<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch,computed } from 'vue'
import CustomList from "../../compositions/CustomList.vue";
import ModalDialog from "../../compositions/ModalDialog.vue";
import SelectBox from "../../compositions/SelectBox.vue";
import TextBox from "../../compositions/TextBox.vue";
import CheckBox from "../../compositions/CheckBox.vue";
import Chart from "../../compositions/Chart.vue";
import OrderHistoryMedicineComponent from "./OrderHistoryMedicineComponent.vue";
import config from "../../config.js";
import { confirmAlert, errorAlert } from "../../plugins/alert";
import { getFieldValue } from "../../plugins/utility";
import qs from 'qs';
import axios from '../../plugins/axios.ts';
import moment from "moment";
import Breakpoint from "../../compositions/Breakpoint.vue";

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    yjCode:{
      type:String,
      default:() => {
        return '';
      },
    },
    identityId:{
      type:Number,
      default:() => {
        return 0;
      },
    },
    isPredictCarry:{
      type:Boolean,
      default:() => {
        return false;
      },
    },
    pharmacyMedicineId:{
      type:Number,
      default:() => {
        return 0;
      },
    },
    onPredictCoverComplete:{
      type:Function,
    },
});
const { yjCode,identityId } = toRefs(props);
const listPrescriptRef = ref();
const isHoverPrescripLoading = ref(false);
const prescriptMaxNumberDay = ref(0);
const prescriptMaxNumberDayPackageUnit = ref('');
const prescriptMaxNumberDayDate = ref('');
const unExpectedPrescriptNumber = ref(0);
// モバイルのみ表示する為のstatus
const isSp: boolean = Breakpoint().isBelow('sm');
const carryOverNumber = ref(0);
const carryOverFlg = ref(false);
const prescriptRegularList = reactive([]);
const hoverPresciptOptions = reactive({
  page_size:30,
  yj_code:'',
});
const getHoverPrescriptDate = async (yjCode) => {
  if (isHoverPrescripLoading.value) {
    return;
  }
  if (!yjCode) {
    return;
  }
  isHoverPrescripLoading.value = true;
  try {
    hoverPresciptOptions.yj_code = yjCode;
    predictCarryDate.value = '';
    predictCarryList.splice(0);
    listPrescriptRef.value.resetItem();
    prescriptRegularList.splice(0);
    unExpectedPrescriptNumber.value = 0;
    carryOverNumber.value = 0;
    carryOverFlg.value = false;

    let params = {'yj_code': yjCode};
    const paramsSerializer = (params) => qs.stringify(params);
    const response = await axios.get(props.apis.pharmacy_medicine_analyze_detail,{params:params,paramsSerializer});
    // TODO 一旦コメント
    //for (let i=0;i<response.data.regular_number.length;i++) {
    //  prescriptRegularList.push(response.data.regular_number[i])
    //}
    prescriptMaxNumberDay.value = response.data.max_number.number;
    prescriptMaxNumberDayDate.value = response.data.max_number.date;
    prescriptMaxNumberDayPackageUnit.value = response.data.max_number.package_unit;
    unExpectedPrescriptNumber.value = response.data.unexpected_prescript_number;
    carryOverNumber.value = response.data.carry_over_number;
    carryOverFlg.value = response.data.carry_over_flg;
  } finally {
    isHoverPrescripLoading.value = false;
    //
  }
}
watch(yjCode,(newValue,oldValue) => {
  hoverPresciptOptions.yj_code = newValue;
  getHoverPrescriptDate(newValue);
});
watch(identityId,(newValue,oldValue) => {
  getHoverPrescriptDate(props.yjCode);
})
////// 予測繰り越し////////////
const predictCarryList = reactive([]);
const onChangePredicteCarryList = (values) => {
  predictCarryList.splice(0);
  for (let i=0;i<values.length;i++) {
    predictCarryList.push(values[i]);
  }
}
const predictCarryDate = ref('');
const onChangePredictCarryDate = (value) => {
  predictCarryDate.value = value;
}
const isPredictCarryLoading = ref(false);
const updatePredictCarry = async () => {
  if (!predictCarryDate.value) {
    errorAlert('繰り越し日を指定してください。');
    return;
  }
  if (predictCarryList.length == 0) {
    errorAlert('繰り越し対象をチェックしてください。');
    return;
  }
  let params = [];
  for (let i=0;i<predictCarryList.length;i++) {
    let item = listPrescriptRef.value.getItemById(predictCarryList[i],'prescript_medicine_id');
    if (item.is_carry) {
      continue;
    }
    params.push({
      pharmacy_medicine_id:props.pharmacyMedicineId,
      prescript_medicine_id:item.prescript_medicine_id,
      carry_over_date:predictCarryDate.value,
      carry_over_number:(item.number*(item.number_day_times > 0 ? item.number_day_times : 1)),
    });
  }
  isPredictCarryLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_medicine_predict_carry_update,{method:"post",data:params});
    if (response.data.status == 200) {
      if (typeof props.onPredictCoverComplete !== 'undefined') {
        props.onPredictCoverComplete();
      }
    }
  } finally {
    isPredictCarryLoading.value = false;
  }

}
const deletePredictCarryConfirm = async (predictCarryId) => {
  let result = await confirmAlert('繰り越しを解除してもよろしいですか？');
  if (result.isConfirmed) {
    await deletePredictCarry(predictCarryId);
  }
}
const deletePredictCarry = async (predictCarryId) => {
  let params = new FormData();
  params.append('id', predictCarryId);
  isPredictCarryLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_medicine_predict_carry_delete,{method:"post",data:params});
    if (response.data.status == 200) {
      if (typeof props.onPredictCoverComplete !== 'undefined') {
        props.onPredictCoverComplete();
      }
    }
  } finally {
    isPredictCarryLoading.value = false;
  }
}
/////////////////////////////

////// 予測繰り越し(再)////////////
const listRePrescriptRef = ref();
const rePredictCarryList = reactive([]);
const onChangeRePredicteCarryList = (values) => {
  rePredictCarryList.splice(0);
  for (let i=0;i<values.length;i++) {
    rePredictCarryList.push(values[i]);
  }
}
const rePredictCarryDate = ref('');
const onChangeRePredictCarryDate = (value) => {
  rePredictCarryDate.value = value;
}
const isRePredictCarryLoading = ref(false);

const updateRePredictCarry = async () => {
  if (!rePredictCarryDate.value) {
    errorAlert('繰り越し日を指定してください。');
    return;
  }
  if (rePredictCarryList.length == 0) {
    errorAlert('繰り越し対象をチェックしてください。');
    return;
  }
  let params = [];
  for (let i=0;i<rePredictCarryList.length;i++) {
    let item = listRePrescriptRef.value.getItemById(rePredictCarryList[i],'prescript_medicine_id');
    params.push({
      pharmacy_medicine_id:props.pharmacyMedicineId,
      prescript_medicine_id:item.prescript_medicine_id,
      carry_over_date:rePredictCarryDate.value,
      carry_over_number:(item.number*(item.number_day_times > 0 ? item.number_day_times : 1)),
    });
  }
  isRePredictCarryLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_medicine_predict_carry_update,{method:"post",data:params});
    if (response.data.status == 200) {
      if (typeof props.onPredictCoverComplete !== 'undefined') {
        props.onPredictCoverComplete();
      }
    }
  } finally {
    isRePredictCarryLoading.value = false;
  }

}
const deleteRePredictCarryConfirm = async (predictCarryId) => {
  let result = await confirmAlert('繰り越しを解除してもよろしいですか？');
  if (result.isConfirmed) {
    await deleteRePredictCarry(predictCarryId);
  }
}

const deleteRePredictCarry = async (predictCarryId) => {
  let params = new FormData();
  params.append('id', predictCarryId);
  isRePredictCarryLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_medicine_predict_carry_delete,{method:"post",data:params});
    if (response.data.status == 200) {
      if (typeof props.onPredictCoverComplete !== 'undefined') {
        props.onPredictCoverComplete();
      }
    }
  } finally {
    isRePredictCarryLoading.value = false;
  }
}
const excludeCheckList = computed(() => {
  let result = [];
  if (typeof listPrescriptRef.value === 'undefined' || listPrescriptRef.value == null) {
    return result;
  }
  //来局済みの患者がいる場合は対象外にする
  let items = listPrescriptRef.value.getItems();
  for (let i=0;i<items.length;i++) {
    if (items[i].is_done) {
      result.push(items[i].prescript_medicine_id);
    }
  }
  return result;
})
/////////////////////////////
</script>

<style scoped>
.is-done {
  text-decoration: line-through;
}
.is-sp-width {
  width: 80vw;
}
</style>
<template>
<div :class="'bg-black text-white p-2 text-sm text-left border border-white ' + (isSp ? 'is-sp-width' : '')">
  <div v-if="isHoverPrescripLoading || isPredictCarryLoading" class="loading-mask">
    <div class="loading-content">
      <span style="color: white"><img src="../../../public/images/loading.gif"></span>
    </div>
  </div>
  <div class="border-b border-white mb-2">
    <div>【1日最大処方】</div>
    <div>{{ prescriptMaxNumberDay }} {{ prescriptMaxNumberDayPackageUnit }}</div>
  </div>
  <div class="flex flex-row items-center justify-start border-b border-white mb-2">
    <div class="mr-1">【対象外】</div>
    <div class="mr-4">{{ unExpectedPrescriptNumber }} {{ prescriptMaxNumberDayPackageUnit }}</div>
    <div class="mr-1">【繰越】</div>
    <div>{{ carryOverNumber }} {{ prescriptMaxNumberDayPackageUnit }}</div>
  </div>
  <div :class="'flex items-center flex-' + (isSp == false ? 'row' : 'col')">
    <div v-if="carryOverFlg" :class="'bg-black text-white pr-2 mr-2 border-r border-white '  + (isSp ? 'w-full' : '')">
      <div class="text-center">--繰越履歴--</div>
      <div class="flex flex-row items-center justify-between mb-1">
        <div :class="'mr-2 ' + (isSp ? 'w-2/5' : 'w-2/3')">
          <text-box
            type="date"
            :value="rePredictCarryDate"
            font-size="0.8em"
            :on-change="onChangeRePredictCarryDate"
          ></text-box>
        </div>
        <div class="w-24">
          <a href="javascript:void(0)" @click="updateRePredictCarry" class="text-xs block text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 rounded-lg px-4 py-1 w-full text-center">予測繰越</a>
        </div>
      </div>
      <custom-list
        ref="listRePrescriptRef"
        :option-fields="hoverPresciptOptions"
        :api-url="apis.pharmacy_medicine_predict_carry_list"
        :is-custom-design="true"
        list-key="prescript_medicine_id"
        :is-checkable="true"
        :check-values="rePredictCarryList"
        :on-check-change="onChangeRePredicteCarryList"
        back-ground-color="#000"
        height="150px"
        width="100%"
      >
      <template v-slot:item="slotProps">
        <div class="bg-black text-white flex flex-col border-b border-white mb-2">
          <div v-if="slotProps.item.is_done">
            【来局済み：{{ slotProps.item.done_number + slotProps.item.unit }}】
          </div>
          <div class="flex justify-between items-center">
            <div :class="'flex flex-col ' + (slotProps.item.is_done ? 'is-done' : '')">
              <div>{{ slotProps.item.target_dispensing_date }}</div>
              <div>{{ slotProps.item.patient_profile != null ? slotProps.item.patient_profile.patient_kanji_name : '' }}</div>
            </div>
            <div :class="'flex flex-col ' + (slotProps.item.is_done ? 'is-done' : '')">
              <div class="mr-2">{{  slotProps.item.number + slotProps.item.unit }}</div>
              <div>{{  slotProps.item.dosage_frequency_label }}</div>
            </div>
          </div>
          <div class="flex flex-col">
            <div :class="(slotProps.item.is_done ? 'is-done' : '')">計{{ (slotProps.item.number*(slotProps.item.number_day_times > 0 ? slotProps.item.number_day_times : 1)).toLocaleString() + slotProps.item.unit }}</div>
            <div v-if="slotProps.item.is_carry != null" class="mb-1">
              <div class="text-xs">繰越日:{{ slotProps.item.carry_over_date }}</div>
              <div><a href="javascript:void(0)" @click="deleteRePredictCarryConfirm(slotProps.item.is_carry)" class="text-xs block text-white bg-red-500 hover:bg-red-400 focus:ring-4 focus:ring-red-200 rounded-lg px-4 py-1 w-full text-center">繰越解除</a></div>
            </div>
          </div>
        </div>
      </template>
      </custom-list>

    </div>
  <!-- TODO 一旦コメント
  <div class="p-1">
    <div v-for="prescriptRegular in prescriptRegularList" :key="prescriptRegular.key">
      {{ prescriptRegular.key }}:{{ prescriptRegular.number }}{{ prescriptRegular.package_unit }}
    </div>
  </div>
  -->
    <div :class="'bg-black text-white '  + (isSp ? 'w-full' : '')">
      <div class="text-center">--来局予定--</div>
      <div class="flex flex-row items-center justify-between mb-1">
        <div :class="'mr-2 ' + (isSp ? 'w-2/5' : 'w-2/3')">
          <text-box
            type="date"
            :value="predictCarryDate"
            font-size="0.8em"
            :on-change="onChangePredictCarryDate"
          ></text-box>
        </div>
        <div class="w-24">
          <a href="javascript:void(0)" @click="updatePredictCarry" class="text-xs block text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 rounded-lg px-4 py-1 w-full text-center">予測繰越</a>
        </div>
      </div>
      <custom-list
        ref="listPrescriptRef"
        :option-fields="hoverPresciptOptions"
        :api-url="apis.pharmacy_medicine_analyze_list"
        :is-custom-design="true"
        list-key="prescript_medicine_id"
        :is-checkable="isPredictCarry"
        :exclude-check-ids="excludeCheckList"
        :check-values="predictCarryList"
        :on-check-change="onChangePredicteCarryList"
        back-ground-color="#000"
        height="150px"
        width="100%"
      >
      <template v-slot:item="slotProps">
        <div class="'bg-black text-white flex flex-col border-b border-white mb-2">
          <div v-if="slotProps.item.is_done">
            【来局済み：{{ slotProps.item.done_number + slotProps.item.unit }}】
          </div>
          <div class="flex justify-between items-center">
            <div :class="'flex flex-col ' + (slotProps.item.is_done ? 'is-done' : '')">
              <div>{{ slotProps.item.target_dispensing_date }}</div>
              <div>{{ slotProps.item.patient_profile != null ? slotProps.item.patient_profile.patient_kanji_name : '' }}</div>
            </div>
            <div :class="'flex flex-col ' + (slotProps.item.is_done ? 'is-done' : '')">
              <div class="mr-2">{{  slotProps.item.number + slotProps.item.unit }}</div>
              <div>{{  slotProps.item.dosage_frequency_label }}</div>
            </div>
          </div>
          <div class="flex flex-col">
            <div :class="(slotProps.item.is_done ? 'is-done' : '')">計{{ (slotProps.item.number*(slotProps.item.number_day_times > 0 ? slotProps.item.number_day_times : 1)).toLocaleString() + slotProps.item.unit }}</div>
            <div v-if="slotProps.item.is_carry != null" class="mb-1">
              <div class="text-xs">繰越日:{{ slotProps.item.carry_over_date }}</div>
              <div><a href="javascript:void(0)" @click="deletePredictCarryConfirm(slotProps.item.is_carry)" class="text-xs block text-white bg-red-500 hover:bg-red-400 focus:ring-4 focus:ring-red-200 rounded-lg px-4 py-1 w-full text-center">繰越解除</a></div>
            </div>
          </div>
        </div>
      </template>
      </custom-list>
    </div>
  </div>
</div>
</template>

